// extracted by mini-css-extract-plugin
export default {"Habitus":"AffichageSyntheseHabitus_Habitus__x3aOM"};